import { supabase } from './supabase';

export async function hardSignOut(redirectTo: string = '/'): Promise<void> {
  try {
    await Promise.race([
      supabase.auth.signOut({ scope: 'local' }),
      new Promise((res) => setTimeout(res, 2000)),
    ]);
  } catch {
    // ignore
  }
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith('sb-'))
      .forEach((key) => localStorage.removeItem(key));
  } catch {
    // ignore
  }
  supabase.auth.signOut({ scope: 'global' }).catch(() => {});
  window.location.replace(redirectTo);
}
